import { useApp } from "../app-context.js";
import { useMoveLayout, useSynchronizedPaneScrolling } from "../hooks/use-move-layout.js";
import { DiffFiles } from "./diff-files.js";
import { MoveLayer, MovePreviews } from "./moves.js";
import { Sidebar } from "./sidebar.js";
import { Summary } from "./summary.js";
import type { FollowMove, MoveRole } from "../types.js";
import { flashMove } from "../lib/focus.js";

export function Viewer({ onReset }: { onReset(): void }) {
  const { analysis, hideUnchangedMoves, reviewed, showReviewed } = useApp();
  const layout = useMoveLayout(analysis, reviewed, showReviewed, hideUnchangedMoves);
  useSynchronizedPaneScrolling(layout);

  const followMove: FollowMove = (id: number, role: MoveRole) => {
    const move = analysis.moves.find((item) => item.id === Number(id));
    if (!move) return;
    const lineId = role === "source" ? move.source.lineIds[0] : move.target.lineIds[0];
    const target = document.getElementById(lineId);
    if (!target) return;
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    flashMove(Number(id));
  };

  return (
    <section class="viewer" id="viewer">
      <Sidebar onFollowMove={followMove} />
      <div class="diff-view">
        <Summary onReset={onReset} />
        <div class="diff-stage" id="diff-stage">
          <MoveLayer layout={layout} onFollowMove={followMove} />
          <div class="files" id="files">
            <DiffFiles onFollowMove={followMove} />
          </div>
          <MovePreviews layout={layout} onFollowMove={followMove} />
        </div>
      </div>
    </section>
  );
}
